import { Box } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { tabActiveBgColor } from '../../utils/themeColor';

const NavLinkItem = ({
  to,
  label,
  active = false,
  isLast = false,
}: {
  to: string;
  label: string;
  active?: boolean;
  isLast?: boolean;
}) => (
  <Box
    component={NavLink}
    to={to}
    sx={{
      textDecoration: 'none',
      px: 3,
      borderRadius: '30px',
      fontWeight: 400,
      fontSize: '14px',
      py: '3px',
      width: '90%',
      textAlign: 'center',
      transition: 'all 0.3s ease',
      '&.active': {
        backgroundColor: tabActiveBgColor,
        color: '#001E60',
      },
      color: '#001E60',
      '&:hover': {
        color: '#0071e3',
        backgroundColor: '#dceffd',
      },
      ...(isLast && {
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
      }),
    }}
  >
    {label}
  </Box>
);

export default NavLinkItem;
